import { matchPath, useLocation } from 'react-router-dom';

export function useActiveContext() {
  const location = useLocation();
  const routeExamMatch = matchPath('/learn/boss/final/:examId/*', location.pathname)
    || matchPath('/learn/cram/exam/:examId/*', location.pathname);
  const routeDeckMatch = matchPath('/learn/deck/:deckId/*', location.pathname)
    || matchPath('/deck/:deckId/*', location.pathname);
  const state = location.state && typeof location.state === 'object' ? location.state : {};

  return {
    examId: routeExamMatch?.params?.examId || state.examId || null,
    deckId: routeDeckMatch?.params?.deckId || state.deckId || null,
  };
}

export default useActiveContext;
